import {call, put, takeLatest} from 'redux-saga/effects';
import alertsActions from '../actions/alerts.actions';
import AlertsApi from '../api/AlertsApi';
import errorActions from '../actions/error.actions';

function* getAlerts(action) {
    try {
        const alerts = yield call(AlertsApi.getAlerts, action.payload);
        yield put(alertsActions.getAlertsSuccess(alerts));
    } catch (e) {
        if (e.response && e.response.data) {
            yield put(errorActions.showErrorMessage(e.response.data));
        }
        yield put(alertsActions.getAlertsFailed(e));
    }
}

function* removeAlerts(action) {
    try {
        yield put(alertsActions.removeAlertsSuccess(action.payload));
    } catch (e) {
        // do nothing
    }
}

function* alertsSaga() {
    yield takeLatest(alertsActions.TYPES.GET_ALERTS, getAlerts);
    yield takeLatest(alertsActions.TYPES.REMOVE_ALERTS, removeAlerts);
}

export default alertsSaga;
